<app-header-nav></app-header-nav>

<div class="container mx-auto p-6 max-w-2xl">
  <div class="flex items-center justify-between mb-6">
    <div class="flex items-center">
      <button mat-icon-button (click)="onBack()"><mat-icon>arrow_back</mat-icon></button>
      <h1 class="text-2xl font-bold ml-2">Ratings & Reviews</h1>
    </div>
    <button mat-raised-button color="primary" (click)="showSubmitForm = !showSubmitForm">
      <mat-icon>rate_review</mat-icon> Write Review
    </button>
  </div>

  <!-- Average -->
  <mat-card class="text-center p-6 mb-6">
    <div class="text-5xl font-bold text-yellow-500">{{ getAverageRating() | number:'1.1-1' }}</div>
    <div class="flex justify-center gap-1 mt-2">
      <mat-icon *ngFor="let star of ratingStars" [class.text-yellow-400]="star <= getAverageRating()" [class.text-gray-300]="star > getAverageRating()">star</mat-icon>
    </div>
    <div class="text-gray-500 mt-1">{{ ratings.length }} reviews</div>
  </mat-card>

  <!-- Submit Form -->
  <mat-card *ngIf="showSubmitForm" class="p-6 mb-6">
    <h3 class="font-bold mb-4">Leave a Review</h3>
    <mat-form-field class="w-full mb-3">
      <mat-label>Subject</mat-label>
      <input matInput [(ngModel)]="newRating.subject">
    </mat-form-field>
    <div class="mb-4">
      <label class="block text-sm mb-2">Rating</label>
      <div class="flex gap-1">
        <button *ngFor="let star of ratingStars" mat-icon-button
          [class.text-yellow-400]="star <= newRating.rating"
          (click)="newRating.rating = star">
          <mat-icon>{{ star <= newRating.rating ? 'star' : 'star_border' }}</mat-icon>
        </button>
      </div>
    </div>
    <mat-form-field class="w-full mb-4">
      <mat-label>Comment</mat-label>
      <textarea matInput [(ngModel)]="newRating.comment" rows="3"></textarea>
    </mat-form-field>
    <div class="flex gap-2">
      <button mat-raised-button color="primary" (click)="submitRating()">Submit</button>
      <button mat-button (click)="showSubmitForm = false">Cancel</button>
    </div>
  </mat-card>

  <!-- Loading -->
  <div *ngIf="isLoading" class="flex justify-center py-8"><mat-spinner></mat-spinner></div>

  <!-- Ratings List -->
  <div *ngIf="!isLoading">
    <mat-card *ngFor="let rating of ratings" class="mb-3 p-4">
      <div class="flex justify-between items-start">
        <div>
          <div class="font-semibold">{{ rating.subject }}</div>
          <div class="flex gap-0.5 mt-1">
            <mat-icon *ngFor="let star of ratingStars" class="text-sm"
              [class.text-yellow-400]="star <= rating.rating"
              [class.text-gray-300]="star > rating.rating">star</mat-icon>
          </div>
          <p class="text-gray-600 mt-2 text-sm">{{ rating.comment }}</p>
        </div>
        <div class="text-xs text-gray-400">{{ rating.date | date:'mediumDate' }}</div>
      </div>
    </mat-card>
    <p *ngIf="ratings.length === 0" class="text-center text-gray-500 py-12">No reviews yet</p>
  </div>
</div>

<app-footer></app-footer>
